import { render, staticRenderFns } from "./IlluMail.vue?vue&type=template&id=1b1b27c2&"
import script from "./IlluMail.vue?vue&type=script&lang=js&"
export * from "./IlluMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports